import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userConferencesStateSelector} from './user-conferences-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const userConferencesLicensedUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    undefined
>('userConferencesLicensedUsers');

export const userConferencesLicensedUsersActions = userConferencesLicensedUsersSlice.actions;

const userConferencesLicensedUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.userPage.tabs.userConferences.licensedUsers.cache;
export const userConferencesLicensedUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.userPage.tabs.userConferences.licensedUsers;
export const userConferencesLicensedUsersResultSelector = getCachedTableResultSelector(
    userConferencesLicensedUsersCacheSelector,
    userConferencesStateSelector,
);
